export class GetOrganisationAction {
  public static readonly type = '[Organisation] GetOrganisationAction';
  constructor(public readonly id: string) {}
}
